import React, { useEffect } from "react";

const publicationFavicon = `data:image/svg+xml;utf8,${encodeURIComponent(`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
    <rect width="64" height="64" rx="14" fill="#111827" />
    <path d="M18 12h20l8 8v32H18z" fill="#f8fafc" />
    <path d="M38 12v10h10" fill="#cbd5e1" />
    <path d="M24 30h16M24 38h16M24 46h11" stroke="#2563eb" stroke-width="4" stroke-linecap="round" />
  </svg>
`)}`;

const Publication = () => {
  useEffect(() => {
    const previousTitle = document.title;
    const previousDescription = document
      .querySelector('meta[name="description"]')
      ?.getAttribute("content");
    const faviconElement = document.querySelector('link[rel="icon"]');
    const previousFavicon = faviconElement?.getAttribute("href");

    document.title = "Laurence Klein — Publication";

    const descriptionTag = document.querySelector('meta[name="description"]');
    if (descriptionTag) {
      descriptionTag.setAttribute(
        "content",
        "Publication page for Laurence Klein with a PDF version available in a new browser tab.",
      );
    }

    if (faviconElement) {
      faviconElement.setAttribute("href", publicationFavicon);
    }

    return () => {
      document.title = previousTitle;
      if (descriptionTag && previousDescription) {
        descriptionTag.setAttribute("content", previousDescription);
      }
      if (faviconElement && previousFavicon) {
        faviconElement.setAttribute("href", previousFavicon);
      }
    };
  }, []);

  return (
    <main className="min-h-screen bg-slate-100 px-6 py-12 md:py-20">
      <div className="mx-auto max-w-3xl rounded-3xl border border-slate-200 bg-white p-8 shadow-sm md:p-12">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-blue-700">Publication</p>
        <h1 className="mt-3 text-3xl font-bold text-slate-900 md:text-4xl">Faith Without Reason Is Blind; Reason Without Faith Is Lame</h1>
        <p className="mt-4 text-base leading-relaxed text-slate-600">
          This page exists as a clean public landing page for the publication link shared on LinkedIn. The PDF opens in a separate browser tab.
        </p>

        <div className="mt-8 flex flex-wrap gap-3">
          <a
            href="/publication.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center rounded-xl bg-slate-900 px-5 py-3 text-sm font-semibold text-white transition hover:bg-slate-800"
          >
            Open Publication PDF
          </a>
          <a
            href="/publication.pdf"
            download
            className="inline-flex items-center rounded-xl border border-slate-300 px-5 py-3 text-sm font-semibold text-slate-700 transition hover:bg-slate-50"
          >
            Download PDF
          </a>
          <a
            href="/"
            className="inline-flex items-center rounded-xl border border-slate-300 px-5 py-3 text-sm font-semibold text-slate-700 transition hover:bg-slate-50"
          >
            Back to Portfolio
          </a>
        </div>

        <div className="mt-10 rounded-2xl border border-slate-200 bg-slate-50 p-5">
          <p className="text-sm font-semibold text-slate-800">Direct PDF link</p>
          <p className="mt-2 break-all text-sm text-slate-600">https://laurenceklein.au/publication.pdf</p>
        </div>
      </div>
    </main>
  );
};

export default Publication;